import { Navigate } from "react-router";

const base_url = process.env.REACT_APP_BASE_URL

export const PublicRoutes = ({ children }) => {
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("token"));
    return getTokenFromLocalStorage === null ? children : (<Navigate to={`${base_url}/`} replace="true" />)
}